import React from 'react';
import { SiteContent } from '../data/content';

interface ContactProps {
  content: SiteContent['contact'];
}

export const Contact: React.FC<ContactProps> = ({ content }) => {
  return (
    <section className="contact-editorial-section" id="contact" aria-labelledby="contact-title">
      <div className="container">
        <div className="contact-inner">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="contact-title" className="contact-headline">
            {content.title}
          </h2>
          <p className="contact-desc">{content.description}</p>
          <a
            className="contact-giant-link"
            href={`mailto:${content.email}`}
            aria-label={`Send email to ${content.email}`}
          >
            <span>{content.email}</span>
            <span className="contact-arrow" aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
};
